<template>
  <v-select :items="items" v-bind="$attrs" v-on="$listeners"></v-select>
</template>

<script>
import Repository from "@/api/repositories";
const JobApi = Repository.get("jobs");

export default {
  data: () => ({
    items: []
  }),
  methods: {
    async getJobs() {
      await JobApi.get()
        .then(response => {
          console.log({ response });
          let {
            data: { data: items }
          } = response;

          this.items = items;
        })
        .catch(() => {
          this.items = [];
        })
    }
  },
  mounted() {
    this.getJobs();
  }
}
</script>